import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../config';

const card = { background: 'var(--surface)', border: '1px solid #e5e7eb', borderRadius: 14, padding: 18, marginBottom: 16 };
const nf = (n) => (n || 0).toLocaleString('it-IT');

// Agente Indaga massivo: completa gli indirizzi incompleti SOLO con match P.IVA (100%).
// Conservativo verso Google (1 ricerca per volta, pause, tetto giornaliero). Solo admin.
export default function IndagaAgenteCard() {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    axios.get(`${API}/indaga/stato`).then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  useEffect(() => { load(); }, [load]);
  useEffect(() => { const t = setInterval(load, 3000); return () => clearInterval(t); }, [load]);

  const toggle = async (attivo) => {
    setBusy(true);
    try {
      await axios.post(`${API}/indaga/agente`, { attivo });
      toast[attivo ? 'success' : 'info'](attivo ? 'Agente Indaga avviato' : 'Agente Indaga fermato');
      load();
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore'); }
    setBusy(false);
  };

  const job = info?.job;
  const running = !!info?.agente_attivo;
  const pct = job && job.total ? Math.round((100 * job.completed) / job.total) : 0;

  return (
    <div style={card}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          <div style={{ fontSize: 16, fontWeight: 800, color: '#0f172a' }}>Agente Indaga — completa indirizzi</div>
          {running && info?.in_attesa && (
            <span className="agente-attesa" style={{ fontSize: 12.5, color: '#b45309', fontWeight: 700 }}>
              ● in attesa di record{info.motivo_attesa ? ` (${info.motivo_attesa})` : ''}
            </span>
          )}
        </div>
        {running
          ? <button className="btn" style={{ background: '#fee2e2', color: '#b91c1c', border: '1px solid #fca5a5', fontWeight: 700 }} disabled={busy} onClick={() => toggle(false)}>Ferma agente</button>
          : <button className="btn btn-primary" disabled={busy || info?.abilitata === false} onClick={() => toggle(true)}>Avvia agente</button>}
      </div>
      <div style={{ fontSize: 13, color: '#64748b', margin: '8px 0 12px' }}>
        Cerca su Google Maps i record con <b>indirizzo incompleto</b> + ragione sociale + P.IVA e
        scrive l'indirizzo <b>solo se la P.IVA del sito combacia</b> (certezza 100%). Conservativo:
        una ricerca per volta, con pause e tetto giornaliero.
      </div>
      <div style={{ fontSize: 14, marginBottom: running ? 10 : 0 }}>
        Record completabili ora: <b style={{ fontSize: 18 }}>{nf(info?.eligibili)}</b>
        {info?.abilitata === false && <span style={{ color: '#b45309', marginLeft: 8 }}>(disabilitato dall'admin)</span>}
      </div>
      {running && job && (
        <div>
          <div style={{ height: 10, background: '#f1f5f9', borderRadius: 6, overflow: 'hidden', marginBottom: 8 }}>
            <div style={{ width: `${pct}%`, height: '100%', background: 'var(--accent)', transition: 'width .4s' }} />
          </div>
          <div style={{ fontSize: 13, display: 'flex', gap: 16, flexWrap: 'wrap' }}>
            <span><b>{nf(job.completed)}</b> / {nf(job.total)} ({pct}%)</span>
            <span style={{ color: '#15803d' }}>Completati: <b>{nf(job.completati)}</b></span>
            <span style={{ color: '#94a3b8' }}>Non confermati: <b>{nf(job.non_confermati)}</b></span>
            <span style={{ color: '#94a3b8' }}>Non trovati: <b>{nf(job.non_trovati)}</b></span>
            <span style={{ color: job.errori ? '#b91c1c' : '#94a3b8' }}>Errori: <b>{nf(job.errori)}</b></span>
          </div>
          {job.current && <div style={{ fontSize: 12.5, color: '#475569', marginTop: 6 }}>In corso: <b>{job.current}</b></div>}
          {job.standby && <div style={{ fontSize: 12.5, color: '#b45309', marginTop: 4 }}>In standby (possibile blocco Google)…</div>}
        </div>
      )}
    </div>
  );
}
